export default __webpack_public_path__ + "static/media/continuing-5.0841a28b.jpg";